module.exports = __webpack_public_path__ + "static/workwise-59413af2b185f9be7f60a04b6eb7bd02.png";